import { arrayContains } from 'utils';
import { CONFIRM_PAYMENT_METHOD_REQUEST } from 'redux/actions';

export const isConfirmPaymentMethod = (state) => arrayContains(state.payment.openRequests, [CONFIRM_PAYMENT_METHOD_REQUEST]);
